import { Pagination, PaginationProps } from "antd";
import { CustomPaginationItem } from "components/Desktop/CustomPaginationItem";
import ProductList from "components/Desktop/ProductList";
import { useState } from "react";
import { useGetFavoriteList } from "services/favorite";

const FavoritesForm = () => {
  const [currentPage, setCurrentPage] = useState<number>(1);
  const { favoriteList, isLoading } = useGetFavoriteList(currentPage);

  if (isLoading || !favoriteList) {
    return <div>Loading...</div>;
  }
  const onChangePage: PaginationProps["onChange"] = (page) => {
    setCurrentPage(page);
  };
  return (
    <div className="min-h-screen">
      <div className="text-primary font-semibold">รายการโปรด</div>
      <div className="flex justify-between mt-4 sm:mt-6">
        <ProductList
          isLoading={isLoading}
          isList={false}
          data={favoriteList.items}
        />
      </div>
      <div className="mt-4 justify-center flex">
        <Pagination
          itemRender={CustomPaginationItem}
          current={currentPage}
          onChange={onChangePage}
          total={favoriteList?.meta.totalItems}
          showSizeChanger={false}
          pageSize={20}
        />
      </div>
    </div>
  );
};
export default FavoritesForm;
